export default __webpack_public_path__ + "9894ad71f8a84ab7711fe58e1f322d41.webp";